import { z } from 'zod';

export const saveToDashboardSchema = z.object({
    dashboardUuid: z.string().nullable(),
    newDashboardName: z.string().min(1).nullable(),
    newDashboardDescription: z.string().nullable(),
});

export type SaveToDashboardFormType = z.infer<typeof saveToDashboardSchema>;

export const saveToSpaceSchema = z.object({
    spaceUuid: z.string().nullable(),
    newSpaceName: z.string().min(1).nullable(),
});

export type SaveToSpaceFormType = z.infer<typeof saveToSpaceSchema>;

export type ChartMetadata = {
    name: string;
    description: string;
};

export const DEFAULT_CHART_METADATA = {
    name: '',
    description: '',
} as const;

export enum SaveDestination {
    Dashboard = 'dashboard',
    OriginatingDashboard = 'originating_dashboard',
    Space = 'space',
}

export enum ModalStep {
    InitialInfo = 0,
    SelectDestination = 1,
}
